"use strict";

exports.__esModule = true;
exports.default = void 0;

var _badge = require("./badge");

var _plugins = require("../../utils/plugins");

var components = {
  BBadge: _badge.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/badge/index.js
// module id = 420
// module chunks = 0